import authFa from './fa.json'

const AuthMessages = {
  fa: {
    ...authFa,
  },
}

export default AuthMessages
